
import BottomFilterModalLayout from '@/components/search/BottomFilterModalLayout.vue';
import KeywordSection from '@/components/search/KeywordSection';
import SearchHeader from '@/components/search/SearchHeader.vue';
import SearchListSection from '@/components/search/SearchListSection';
import { INITIATE_SEARCH } from '@/utils/amplitudeEvent/amplitudeEvents.js';
import getFilterText from '@/utils/filter/getFilterText';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'Search',
  components: {
    SearchListSection,
    KeywordSection,
    SearchHeader,
    BottomFilterModalLayout,
  },
  asyncData({ query, store }) {
    const isSearchQuery = !!query.order;
    let title = '수업 찾기';
    let summary = '';
    if (isSearchQuery) {
      if (query.keyword) {
        title = `${query.keyword} 관련 수업`;
      } else if (query.selectedCategory) {
        const categoryList = store.getters['filter/categoryList'];
        const category = categoryList.find(
          x => x.id === parseInt(query.selectedCategory),
        );
        title = category ? category.title : '검색한 결과';
      } else if (query.selectedAge) {
        title = `지금 ${query.selectedAge}살 아이가 듣는  수업`;
      } else {
        title = '검색한 결과';
      }

      summary = getFilterText(query);
    }
    return {
      title,
      summary,
    };
  },
  data() {
    return {
      title: '수업 찾기',
      summary: '',
    };
  },
  head({ $config }) {
    return {
      title: this.title,
      titleTemplate: `%s | 꾸그 - ${$config.SITE_TITLE}`,
      meta: [
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.summary?.split(' ').join(', '),
        },
        {
          hid: 'description',
          name: 'description',
          content: this.summary,
          itemprop: 'description',
        },
        {
          hid: 'og:type',
          property: 'og:type',
          content: 'website',
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: `꾸그 - ${this.title}`,
          itemprop: 'name',
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.summary,
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: this.$route.fullPath,
          itemprop: 'url',
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: `꾸그 - ${this.title}`,
        },
        {
          hid: 'twitter:url',
          name: 'twitter:url',
          content: this.$route.fullPath,
        },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: this.summary,
        },
      ],
      link: [{ rel: 'canonical', href: this.$route.fullPath }],
    };
  },
  computed: {
    ...mapGetters('user', ['userChildrenAgesArrayForFilter']),
    ...mapGetters('search', ['activeBottomDrawerFilter']),
    ...mapGetters('filter', ['categoryList']),
    isSearchQuery() {
      if (this.$route.query.order !== undefined) return true;
      if (this.$route.query.listType !== undefined) return true;
      if (this.$route.query.keyword !== undefined) return true;
      return false;
    },
  },
  watch: {
    /**
     * @description 검색 쿼리가 변경되면 브라우저 탭 타이틀 변경
     */
    $route({ query }) {
      this.makeTitle(query);
    },
  },
  /**
   * @description
   * 로그인 했을 때 아이 연령 정보 추가
   */
  mounted() {
    // order가 없다면 검색 진입페이지로 판단
    if (!this.isSearchQuery) {
      this.title = '수업 찾기';
      // 로그인 상태라면 아이 나이 자동 세팅
      if (this.$auth.loggedIn)
        this.SET_SELECTED_AGE([...this.userChildrenAgesArrayForFilter]);

      const fromParam = this.$route.params?.from;
      this.logUserCustomEvent(INITIATE_SEARCH, { from: fromParam });
    }
    this.makeTitle(this.$route.query);
  },
  destroyed() {
    this.ALL_RESET_SEARCH_FILTER();
    this.RESET_SEARCH();
  },
  methods: {
    ...mapMutations('search', [
      'RESET_SEARCH',
      'SET_ACTIVE_BOTTOM_DRAWER_FILTER',
    ]),
    ...mapMutations('search/filter', [
      'ALL_RESET_SEARCH_FILTER',
      'SET_SELECTED_PERIOD_OPTION',
      'SET_SELECTED_AGE',
    ]),

    /**
     * @description 브라우저 탭 타이틀 작성
     */
    makeTitle(query) {
      if (query.keyword) {
        this.title = `${query.keyword} 관련 수업`;
      } else if (query.selectedCategory) {
        const categoryId = parseInt(query.selectedCategory);
        if (!isNaN(categoryId)) {
          const category = this.categoryList.find(x => x.id === categoryId);
          this.title = category ? category.name : '검색한 결과';
        }
      } else if (query.selectedAge) {
        this.title = `지금 ${query.selectedAge}살 아이가 듣는  수업`;
      } else {
        this.title = '검색한 결과';
      }
    },
  },
};
